import { StytchProvider } from '@stytch/react';
import { StytchHeadlessClient } from '@stytch/vanilla-js/headless';
import React from 'react';

import type { ContainerComponent } from '../../common/types/Common';
import { STYTCH_PUBLIC_TOKEN } from '../../config/config';

export const stytchClient = new StytchHeadlessClient(STYTCH_PUBLIC_TOKEN);

const AuthProvider: ContainerComponent = ({ children }) => {
    return <StytchProvider stytch={stytchClient}>{children}</StytchProvider>;
};

export default AuthProvider;
